import { render, staticRenderFns } from "./FakeTab.vue?vue&type=template&id=559d7b0f"
import script from "./FakeTab.vue?vue&type=script&lang=js"
export * from "./FakeTab.vue?vue&type=script&lang=js"
import style0 from "./FakeTab.vue?vue&type=style&index=0&id=559d7b0f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports